import LoaderIcon from 'shared/icons/loader.svg';
import { ConstructionModal } from 'shared/ui/modal';
import styles from './loading.module.scss';

// используется только в QuestionnairePage и EsiaCallbackPage
// в других местах надо использовать компонент Loader
export const Loading = () => {
  return (
    <ConstructionModal backgroundClassName={styles.background}>
      <div className={styles.modal}>
        <div className={styles.loader}>
          <img src={LoaderIcon} alt="" width={132} height={132} className={styles.icon} />
          <span className={styles.text}>Загружаем данные</span>
        </div>
      </div>
    </ConstructionModal>
  );
};
